<script setup lang="ts">
import { toRef } from 'vue'

import type { UserTag } from '@/types/userTags'
import BoxComponent from '@/ui-library/atoms/BoxComponent/BoxComponent.vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import TypographyComponent from '@/ui-library/atoms/TypographyComponent/TypographyComponent.vue'

const props = defineProps<{
  userTags: UserTag[]
}>()

const tagIds = defineModel<number[]>('tagIds', { default: [] })
const tags = toRef(props, 'userTags')

const handleTagSwitch = (value: string | number | boolean, id: number) => {
  if (value) {
    tagIds.value.push(id)
  } else {
    tagIds.value = tagIds.value.filter((item) => item !== id)
  }
}
</script>

<template>
  <FlexComponent :gap="8" direction="column">
    <BoxComponent v-for="tag in tags" :key="tag.id" :p="16" class="tag-container">
      <FlexComponent :gap="16" align="center">
        <div class="flex-1">
          <TypographyComponent variant="title-large">{{ tag.name }}</TypographyComponent>
          <TypographyComponent variant="body-medium">
            {{ tag.usersCount }} creators · {{ tag.totalFollowers }} followers
          </TypographyComponent>
        </div>
        <el-switch :model-value="tagIds.includes(tag.id)" size="large" @change="(value) => handleTagSwitch(value, tag.id)" />
      </FlexComponent>
    </BoxComponent>
  </FlexComponent>
</template>

<style scoped>
.tag-container {
  border-radius: 8px;
  border: 1px solid rgba(3, 30, 81, 0.12);
  background: #fff;
}
</style>
